import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import { notificationsApi, leaguesApi } from '../services/api';

function Notifications({ user, onLogout }) {
  const [message, setMessage] = useState('');
  const [target, setTarget] = useState('all');
  const [leagueId, setLeagueId] = useState('');
  const [leagues, setLeagues] = useState([]);
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    leaguesApi.getAll().then(res => {
      setLeagues(res.data?.leagues || res.leagues || []);
    }).catch(() => {});
  }, []);

  const handleSend = async () => {
    if (!message.trim()) { setError('Message is required'); return; }
    setSending(true);
    setError(null);
    setResult(null);
    try {
      const payload = { message: message.trim() };
      if (target === 'all') payload.all = true;
      else if (target === 'league') payload.leagueId = leagueId;

      const res = await notificationsApi.sendSMS(payload);
      setResult(res.data || res);
    } catch (e) {
      setError(e.message || 'Failed to send');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="admin-layout">
      <Sidebar user={user} onLogout={onLogout} />
      <main className="main-content">
        <div className="page-header">
          <h2>Notifications</h2>
          <p>Send SMS messages to players</p>
        </div>

        <div className="card">
          <div className="card-header"><h3>Send SMS</h3></div>
          <div style={{ padding: 20 }}>
            <div className="form-group">
              <label>Send To</label>
              <select className="form-select" value={target} onChange={e => setTarget(e.target.value)}>
                <option value="all">All Players</option>
                <option value="league">Players in a League</option>
              </select>
            </div>

            {target === 'league' && (
              <div className="form-group">
                <label>League</label>
                <select className="form-select" value={leagueId} onChange={e => setLeagueId(e.target.value)}>
                  <option value="">Select a league...</option>
                  {leagues.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
                </select>
              </div>
            )}

            <div className="form-group">
              <label>Message</label>
              <textarea
                className="form-input"
                rows={4}
                value={message}
                onChange={e => setMessage(e.target.value)}
                placeholder="Type your message here... (160 char max for single SMS)"
                maxLength={500}
              />
              <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>{message.length}/500 characters</div>
            </div>

            {error && <div className="error-message">{error}</div>}

            <button className="btn btn-primary" onClick={handleSend} disabled={sending || !message.trim()}>
              {sending ? 'Sending...' : 'Send SMS'}
            </button>
          </div>
        </div>

        {result && (
          <div className="card" style={{ marginTop: 20 }}>
            <div className="card-header"><h3>Result</h3></div>
            <div style={{ padding: 20 }}>
              {result.preview ? (
                <>
                  <div style={{ background: '#fef3c7', border: '1px solid #fcd34d', borderRadius: 8, padding: 12, marginBottom: 16 }}>
                    <strong>Preview Mode</strong> — Twilio not configured. No messages sent.
                  </div>
                  <p><strong>Would send to:</strong> {result.recipientCount} players</p>
                  <p><strong>Message:</strong> {result.message}</p>
                  {result.recipients?.length > 0 && (
                    <div style={{ marginTop: 12 }}>
                      <strong>Sample recipients:</strong>
                      <ul style={{ fontSize: 13, marginTop: 4 }}>
                        {result.recipients.map((r, i) => (
                          <li key={i}>{r.name} — {r.phone}</li>
                        ))}
                      </ul>
                      {result.recipientCount > 20 && <p style={{ color: '#888', fontSize: 12 }}>...and {result.recipientCount - 20} more</p>}
                    </div>
                  )}
                </>
              ) : (
                <>
                  <p style={{ fontSize: 18 }}>
                    Sent: <strong style={{ color: '#16a34a' }}>{result.sent}</strong>
                    {result.failed > 0 && <> &middot; Failed: <strong style={{ color: '#dc2626' }}>{result.failed}</strong></>}
                    &middot; Total: {result.total}
                  </p>
                  {result.errors?.length > 0 && (
                    <div style={{ marginTop: 12, fontSize: 13, color: '#dc2626' }}>
                      {result.errors.map((e, i) => <div key={i}>{e.phone}: {e.error}</div>)}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default Notifications;
